<template>
  <TwoColumn class="max-w-screen-lg">
    <template #left>
      <h1 class="text-2xl font-bold leading-[30px]">
        {{ $t("pages.500.title") }}
      </h1>

      <p class="font-medium leading-6">
        {{ $t("pages.500.message") }}
      </p>
      <p class="font-medium leading-6">
        {{ $t("common.labels.error_contact_us_message") }}
        <a
          href="#"
          class="lowercase text-[--color-link] hover:text-[--color-neutral-a1]"
          @click.prevent="openLivePersonChat"
        >
          {{ $t("common.links.contact_us") }} </a
        >.
      </p>
      <div class="mt-5 flex w-full flex-col gap-5 md:flex-row">
        <VcButton
          :to="$t('common.links.catalog_link')"
          class="h-[48px] md:!min-w-[215px]"
          color="primary"
          variant="solid"
          size="lg"
        >
          {{ $t("common.buttons.view_catalog") }}
        </VcButton>
        <VcButton to="/" class="h-[48px] md:!min-w-[118px]" color="secondary" variant="outlineTL" size="lg">
          {{ $t("common.buttons.go_home") }}
        </VcButton>
      </div>
    </template>
    <template #right>
      <VcImage
        src="/static/thorlabs/OhNo_Dog1.webp"
        :alt="$t('pages.500.img_alt')"
        class="h-[125px] w-[150px] md:h-[167px] md:w-[200px]"
        lazy
      />
    </template>
  </TwoColumn>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";
import { usePageHead } from "@/core/composables";
import { TwoColumn } from "@/shared/layout";
import { useLivePerson } from "@/shared/live-person";

const { t } = useI18n();

usePageHead({
  title: t("pages.500.title"),
});

function openLivePersonChat() {
  useLivePerson().openLivePersonChat();
}
</script>

<style scoped lang="scss">
.vc-typography--variant--h1 {
  @apply normal-case;
}
</style>
